
export const featuredBooks = [
  {
    id: 1,
    title: "The Dream Journal",
    description: "A guided journey to record your dreams, reflect deeply, and move boldly toward purpose. Discover divine inspiration and take practical steps toward achieving your God-given goals.",
    category: "Journals & Workbooks",
    price: 24.99,
    digitalPrice: 14.99,
    rating: 4.9,
    reviews: 127,
    image: "https://static.readdy.ai/image/b75c0c2a711814bf71b853c42d7775ec/12830301fa3ddf5f013dc5710f5476dd.jfif"
  },
  {
    id: 2,
    title: "The Dream Journal T-Shirt",
    description: "Premium quality cotton t-shirt featuring The Dream Journal inspirational design. Comfortable fit perfect for daily wear while pursuing your dreams and goals.",
    category: "Apparel",
    price: 19.99,
    digitalPrice: 0, // No digital version for physical products
    rating: 4.7,
    reviews: 89,
    image: "https://public.readdy.ai/ai/img_res/9c1b07457f3b68a462aaef1b37326fa7.jpg"
  }
];

export const allBooks = [
  {
    id: 1,
    title: "The Dream Journal",
    description: "A guided journey to record your dreams, reflect deeply, and move boldly toward purpose. Discover divine inspiration and take practical steps toward achieving your God-given goals.",
    category: "Journals & Workbooks",
    price: 24.99,
    digitalPrice: 14.99,
    rating: 4.9,
    reviews: 127,
    image: "https://static.readdy.ai/image/b75c0c2a711814bf71b853c42d7775ec/12830301fa3ddf5f013dc5710f5476dd.jfif"
  },
  {
    id: 2,
    title: "The Dream Journal T-Shirt",
    description: "Premium quality cotton t-shirt featuring The Dream Journal inspirational design. Comfortable fit perfect for daily wear while pursuing your dreams and goals.",
    category: "Apparel",
    price: 19.99,
    digitalPrice: 0,
    rating: 4.7,
    reviews: 89,
    image: "https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20with%20inspirational%20dream%20journal%20design%2C%20comfortable%20casual%20wear%2C%20modern%20typography%2C%20motivational%20quote%2C%20clean%20white%20background%2C%20product%20photography%20style%2C%20high%20quality%20fabric%20texture%2C%20lifestyle%20apparel&width=400&height=500&seq=tshirt001&orientation=portrait"
  }
];

export const bookCategories = [
  "Journals & Workbooks",
  "Apparel"
];
